<template>
  <div>
    <Navbar v-if="this.$route.name == 'aggregatedreportsettings'"/>
    <Breadcrumb v-if="this.$route.name == 'aggregatedreportsettings'" />     
    <b-tabs class="col-12 px-0 mx-0 mt-2" content-class="mt-3">
      <b-tab class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="col-12 text-center">
            <fa-icon
              class="mr-2"
              name="money-bill"
            />Pricing
          </div>
        </template>
        <b-card no-body class="border-0 mx-0 px-0 pl-0 pr-0 col-12">
          <b-row>
            <b-form-group 
              label-cols="4"
              label="VAT rate (%)"
              class="col-12"
            >
              <b-form-input  
                id="aggregated_vat" 
                class="form-control col-7"
                v-model="aggregated_vat"
                v-on:change="savepref('aggregated_vat',aggregated_vat)" 
                autocomplete="off"
              >
              </b-form-input>
            </b-form-group>
          </b-row>
          <b-row>
            <b-form-group 
              label-cols="4"
              label="Aggregated Report price"
              class="col-12"
            >
              <b-form-input  
                id="aggregated_price" 
                class="form-control col-7"
                v-model="aggregated_price"
                v-on:change="savepref('aggregated_price',aggregated_price)" 
                autocomplete="off"
              >
              </b-form-input>
            </b-form-group>
          </b-row>
        </b-card>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import Navbar from './Navbar.vue';
import Breadcrumb from './Breadcrumb.vue';
export default {
  name: 'AggregatedReportSettings',
  mounted() {
    this.prefs_get();
  },
  components: {
    Navbar,
    Breadcrumb
  },
  data: function() {
    return {
      aggregated_price: 0,
      aggregated_vat: 0,
    }
  },
  methods: {
    savepref(key,value) {
      if (key.indexOf('_date') != -1) {
        value = this.format_date(value);
      }
      this.$store.dispatch('syspref_save', { key: key,value: value });
    },
    prefs_get() {
      this.$store.dispatch('syspref_fetch', { key: 'aggregated_price' })
      .then((resp) => {
        this.aggregated_price = resp.data.value;
        this.$store.dispatch('syspref_fetch', { key: 'aggregated_vat' })
        .then((resp) => {
          this.aggregated_vat = resp.data.value;
        });
      });
    },
  },
}
</script>
<style>
</style>
